import { forwardRef } from "react";

/**
 * Scrollable chat log. Bubble styles differ for user vs. assistant.
 */
const MessageList = forwardRef(function MessageList({ messages, busy }, ref) {
  return (
    <div
      ref={ref}
      data-testid="chat-scroll"
      className="flex-1 overflow-y-auto px-4 py-4 space-y-3"
    >
      {messages.map((m, i) => (
        <div
          key={`${m.role}-${i}-${(m.text || "").slice(0, 12)}`}
          className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}
        >
          <div
            className={`max-w-[88%] px-4 py-2.5 rounded-2xl text-sm leading-relaxed whitespace-pre-wrap ${
              m.role === "user"
                ? "bg-gradient-to-br from-[#00E5FF]/20 to-[#7B2CBF]/20 border border-[#00E5FF]/30 text-[#0F172A]"
                : "glass text-[#0F172A]"
            }`}
          >
            {m.text || (busy && i === messages.length - 1 ? <span className="text-[#64748B]">…</span> : "")}
          </div>
        </div>
      ))}
    </div>
  );
});

export default MessageList;
